import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// @mui material components
import { Tab, Tabs, Grid, Card } from '@mui/material';

// Material Dashboard 2 React components
import MDBox from 'components/MDBox';

import Transactions from './components/Transactions';

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

const TransactionsManagement = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [value, setValue] = useState('Primary');

  const handleTabSelect = (tabKey) => {
    switch (tabKey) {
      case 'Primary':
        navigate(
          {
            hash: 'Primary',
          },
          { replace: true }
        );
        setValue(tabKey);
        break;

      case 'Secondary':
        navigate(
          {
            hash: 'Secondary',
          },
          { replace: true }
        );
        setValue(tabKey);
        break;

      case 'Open':
        navigate(
          {
            hash: 'Open',
          },
          { replace: true }
        );
        setValue(tabKey);
        break;

      case 'Cancelled':
        navigate(
          {
            hash: 'Cancelled',
          },
          { replace: true }
        );
        setValue(tabKey);
        break;

      case 'Withdrawal':
        navigate(
          {
            hash: 'Withdrawal',
          },
          { replace: true }
        );
        setValue(tabKey);
        break;

      default:
        navigate(
          {
            hash: 'Primary',
          },
          { replace: true }
        );
        setValue('Primary');
        break;
    }
  };

  const handleChange = (_, newValue) => {
    handleTabSelect(newValue);
  };

  useEffect(() => {
    if (location.hash === '') {
      navigate(
        {
          hash: 'Primary',
        },
        { replace: true }
      );
    } else {
      handleTabSelect(location.hash?.replace('#', ''));
    }
  }, [location.hash]);

  return (
    <MDBox pt={6} pb={3}>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Card>
            <MDBox>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab label="Primary" value="Primary" {...a11yProps(0)} />
                <Tab label="Secondary" value="Secondary" {...a11yProps(1)} />
                <Tab label="Open" value="Open" {...a11yProps(2)} />
                <Tab label="Cancelled" value="Cancelled" {...a11yProps(3)} />
                <Tab label="Withdrawal" value="Withdrawal" {...a11yProps(4)} />
              </Tabs>
            </MDBox>
            <TabPanel value={value} index={'Primary'}>
              <Transactions transactionType="primary" />
            </TabPanel>
            <TabPanel value={value} index={'Secondary'}>
              <Transactions transactionType="secondary" />
            </TabPanel>
            <TabPanel value={value} index={'Open'}>
              <Transactions transactionType="open" />
            </TabPanel>
            <TabPanel value={value} index={'Cancelled'}>
              <Transactions transactionType="cancelled" />
            </TabPanel>
            <TabPanel value={value} index={'Withdrawal'}>
              <Transactions transactionType="withdrawal" />
            </TabPanel>
          </Card>
        </Grid>
      </Grid>
    </MDBox>
  );
};

export default TransactionsManagement;
